import { MyCourseLocation } from "./MyCourseLocation";
import { MyCoursePace } from "./MyCoursePace";

export function MyCourseLogistics() {
	return (
		<div className="my-course-basic-info-container">
			<MyCoursePace />
			<div className="section-separator" />
			<MyCourseLocation />
		</div>
	);
}
